import { action, observable } from 'mobx'

import IsTenantAvaibleOutput from '@services/account/dto/isTenantAvailableOutput'
import accountService from '@services/account/accountService'
import ForgotPasswordModel, {ResetPasswordModel} from '@models/account/ForgotPassword/forgotPasswordModel'
import tokenAuthService from '@services/tokenAuth/tokenAuthService'
import AppConsts from '@lib/appconst'

class AccountStore {
  @observable isLoading!: boolean
  @observable tenant: IsTenantAvaibleOutput = new IsTenantAvaibleOutput()
  @observable forgotPasswordModel: ForgotPasswordModel = new ForgotPasswordModel()
  @observable project: any = {}

  get projectId() {
    return this.project?.id || 0
  }
  @action
  public isTenantAvailable = async (tenancyName: string) => {
    this.tenant = await accountService.isTenantAvailable({ tenancyName: tenancyName })
  }

  @action
  public async requestForgotPassword(model: ForgotPasswordModel) {
    let result = true
    this.isLoading = true
    await accountService.forgotPassword(model).catch((err) => {
      result = false
    }).finally(() => this.isLoading = false)

    return result
  }

  /**
   * Ném tiếp lỗi từ API thay vì trả về false. Endpoint VerifyPasswordResetCode không
   * có payload, nên "chạy xong mà không ném" chính là tín hiệu thành công; còn lý do
   * thất bại (mã sai, mã đã hết hạn, hoặc tài khoản bị khoá vì thử quá nhiều lần)
   * chỉ nằm trong error.message. Nuốt lỗi ở đây làm mất toàn bộ các thông báo đó và
   * dồn tất cả về một câu chung chung.
   */
  @action
  public async verifyCodeForgotPassword(param: any) {
    this.isLoading = true
    await accountService
      .verifyCodeForgotPassword(param, {
        // forgot-password page surfaces errors inline — no global toast
        skipErrorNotification: true,
      })
      .finally(() => (this.isLoading = false))
  }

  @action
  public async resetPassword(model: ResetPasswordModel) {
    let result = true
    this.isLoading = true
    await accountService.resetPasswordUser(model).catch((err) => {
      result = false
    }).finally(() => this.isLoading = false)

    return result
  }

  @action
  async changeProject(project) {
    const result = await tokenAuthService.switchProject(project.id).finally(() => this.project = project)
    // Set token expire date to 10 years (315360000 seconds)
    const tokenExpireDate = new Date(new Date().getTime() + 1000 * 315360000)
    abp.auth.setToken(result.accessToken, tokenExpireDate)
    abp.utils.setCookieValue(
      AppConsts.authorization.encrptedAuthTokenName,
      result.encryptedAccessToken,
      tokenExpireDate,
      "/",
      undefined,
      {
        Secure: true,
        SameSite: "Lax",
        MaxAge: 315360000,
        path: "/"
      }
    )
  }
}

export default AccountStore
